/** A decoration charge's name on a PO: the name it was given on the quote
 *  ("Setup Charge", "Run Charge"), else its type ("Setup"). Nothing else —
 *  never "Other — Setup" (Stephanie 2026-10-27). */
export function poChargeName(c: { chargeType: string; note: string | null | undefined }): string {
  const own = c.note?.trim();
  if (own) return own;
  const t = c.chargeType.replace(/_/g, " ").trim();
  return t ? t.charAt(0).toUpperCase() + t.slice(1) : "Charge";
}
